import React from "react";

const donationRows = [
  { id: 1, name: "Flood Rescue Fund - Siem Reap", month: "January", amount: "3000 $", points: 50 },
  { id: 2, name: "Flood Rescue Fund - Siem Reap", month: "February", amount: "2000 $", points: 60 },
  { id: 3, name: "Flood Rescue Fund - Siem Reap", month: "March", amount: "2000 $", points: 60 },
  { id: 4, name: "Flood Rescue Fund - Siem Reap", month: "April", amount: "2000 $", points: 50 },
  { id: 5, name: "Flood Rescue Fund - Siem Reap", month: "May", amount: "2000 $", points: 50 },
];

const eventRows = [
  { id: 1, name: "Fund collection for flood survivors", date: "Aug 20 2024", duration: "3 hr", points: 5 },
  { id: 2, name: "Fund collection for flood survivors", date: "Aug 20 2024", duration: "3 hr", points: 6 },
  { id: 3, name: "Fund collection for flood survivors", date: "Aug 20 2024", duration: "3 hr", points: 3 },
  { id: 4, name: "Fund collection for flood survivors", date: "Aug 20 2024", duration: "3 hr", points: 5 },
];

const campaignRows = [
  { id: 1, name: "Fund collection for flood survivors", date: "Aug 20 2024", amount: "2000 $", points: 5 },
  { id: 2, name: "Fund collection for flood survivors", date: "Aug 20 2024", amount: "2000 $", points: 6 },
  { id: 3, name: "Fund collection for flood survivors", date: "Aug 20 2024", amount: "2000 $", points: 2 },
  { id: 4, name: "Fund collection for flood survivors", date: "Aug 20 2024", amount: "2000 $", points: 2 },
];

const CompanyProfilePage = () => {
  return (
    <main className="company-page">
      {/* ====== TOP BANNER + LOGO ====== */}
      <section className="company-banner">
        <img
          src="/images/company_pp.jpg"
          alt="Company workspace"
          className="company-banner-img"
        />

        <div className="company-logo-wrapper">
          <img src="/images/company_profile_pic.jpg" alt="Company logo" />
        </div>
      </section>

      {/* ====== ORG SUMMARY ====== */}
      <section className="company-summary">
        <div className="company-summary-main">
          <p className="verified-pill">
            <span className="verified-dot" />
            Verified by Worldtrust
          </p>

          <h1 className="company-title">Worldtrust Associates</h1>
          <p className="company-location">High Street, Singapore</p>

          <p className="company-text">
            Metropolitan YMCA (MYMCA) leads positive community transformation
            with a special focus on children and youths. We nurture our children
            and work with our youth to identify their aspirations and amplify
            their efforts to reach out to the community for positive
            transformation.
          </p>
          <p className="company-text">
            Apart from our community and youth impact efforts, we are also a
            social enterprise, providing affordable F&amp;B and hospitality
            services. All net surpluses from our F&amp;B and hospitality
            businesses contribute to our M.Y programmes which reach out to
            impact the community positively.
            <button className="inline-link">View more</button>
          </p>
        </div>

        <div className="company-summary-actions">
          <div className="social-icon-btn">
            <img src="/images/facebook_icon.png" alt="Facebook" />
          </div>
          <div className="social-icon-btn">
            <img src="/images/mail_icon.png" alt="Email" />
          </div>
          <div className="social-icon-btn">
            <img src="/images/website_icon.png" alt="Website" />
          </div>
          <div className="social-icon-btn">
            <img src="/images/phone_icon.png" alt="Phone" />
          </div>
          <div className="social-icon-btn">
            <img src="/images/share_icon.png" alt="Share" />
          </div>
        </div>
      </section>

      {/* ====== BADGES SECTION ====== */}
      <section className="badges-section">
        <h2 className="section-title">Worldtrust Badges</h2>

        <div className="badges-layout">
          <div className="badge-main">
            <img src="/images/bronze.png" alt="Bronze main badge" />
          </div>

          <div className="badge-row">
            <div className="badge-item">
              <img src="/images/iron.png" alt="Iron badge" />
              {/* <p className="badge-caption">Iron</p> */}
            </div>
            <div className="badge-item">
              <img src="/images/bronze.png" alt="Bronze badge" />
              {/* <p className="badge-caption">Bronze</p> */}
            </div>
            <div className="badge-item">
              <img src="/images/silver2.png" alt="Silver badge" />
              <p className="badge-caption">100 points to go</p>
            </div>
            <div className="badge-item">
              <img src="/images/gold.png" alt="Gold badge" />
              <p className="badge-caption">300 points to go</p>
            </div>
            <div className="badge-item">
              <img src="/images/diamond.png" alt="Diamond badge" />
              <p className="badge-caption">500 points to go</p>
            </div>
          </div>
        </div>
      </section>

      
      <section className="stats-block">
        <h2 className="section-title">Donation &amp; Merit Points</h2>

        <div className="stats-two-column">
          <div className="stats-cards-column">
            <div className="stats-card">
              <div className="stats-card-icon">
                <img src="/images/wallets.png" alt="" />
              </div>
              <div>
                <p className="stats-card-label">Total Donation amount</p>
                <p className="stats-card-value">2000 $</p>
              </div>
            </div>

            <div className="stats-card">
              <div className="stats-card-icon">
              <img src="/images/wallets.png" alt="" />
              </div>
              <div>
                <p className="stats-card-label">Total Merit Points earned</p>
                <p className="stats-card-value">550</p>
              </div>
            </div>

            <div className="stats-card">
              <div className="stats-card-icon">
              <img src="/images/wallets.png" alt="" />
              </div>
              <div>
                <p className="stats-card-label">Total No. of donations</p>
                <p className="stats-card-value">67</p>
              </div>
            </div>
          </div>

          <div className="stats-table-column">
            <div className="table-header-row">
              <p className="table-title">Donations</p>
              <button className="table-filter">
                Monthly <span className="chevron">▾</span>
              </button>
            </div>

            <div className="table-wrapper">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>S. No.</th>
                    <th>Donations</th>
                    <th>Month</th>
                    <th>Amount</th>
                    <th>Merit Points</th>
                  </tr>
                </thead>
                <tbody>
                  {donationRows.map((row) => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>{row.name}</td>
                      <td>{row.month}</td>
                      <td>{row.amount}</td>
                      <td className="positive">{row.points}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

       {/* ====== PARTICIPATED EVENTS ======  */}
      <section className="stats-block">
        <h2 className="section-title">Participated Events</h2>

        <div className="stats-two-column">
          <div className="stats-cards-column">
            <div className="stats-card">
              <div className="stats-card-icon">
              <img src="/images/wallets.png" alt="" />
              </div>
              <div>
                <p className="stats-card-label">Total Participated events</p>
                <p className="stats-card-value">132</p>
              </div>
            </div>

            <div className="stats-card">
              <div className="stats-card-icon">
              <img src="/images/wallets.png" alt="" />
              </div>
              <div>
                <p className="stats-card-label">
                  Total Merit Points earned from events
                </p>
                <p className="stats-card-value">75</p>
              </div>
            </div>
          </div>

          <div className="stats-table-column">
            <div className="table-header-row">
              <p className="table-title">Participation</p>
              <button className="table-filter">
                Monthly <span className="chevron">▾</span>
              </button>
            </div>

            <div className="table-wrapper">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Events</th>
                    <th>Date</th>
                    <th>Event Duration</th>
                    <th>Merit Points</th>
                  </tr>
                </thead>
                <tbody>
                  {eventRows.map((row) => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>{row.name}</td>
                      <td>{row.date}</td>
                      <td>{row.duration}</td>
                      <td className="positive">{row.points}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* ====== PARTICIPATED CAMPAIGNS ======  */}
      <section className="stats-block">
        <h2 className="section-title">Participated Campaigns</h2>

        <div className="stats-two-column">
          <div className="stats-cards-column">
            <div className="stats-card">
              <div className="stats-card-icon">
              <img src="/images/wallets.png" alt="" />
              </div>
              <div>
                <p className="stats-card-label">Total Participated Campaigns</p>
                <p className="stats-card-value">34</p>
              </div>
            </div>

            <div className="stats-card">
              <div className="stats-card-icon">
              <img src="/images/wallets.png" alt="" />
              </div>
              <div>
                <p className="stats-card-label">
                  Total Merit Points earned from campaigns
                </p>
                <p className="stats-card-value">120</p>
              </div>
            </div>
          </div>

          <div className="stats-table-column">
            <div className="table-header-row">
              <p className="table-title">Participation</p>
              <button className="table-filter">
                Monthly <span className="chevron">▾</span>
              </button>
            </div>

            <div className="table-wrapper">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Campaigns</th>
                    <th>Date</th>
                    <th>Donated Amount</th>
                    <th>Merit Points</th>
                  </tr>
                </thead>
                <tbody>
                  {campaignRows.map((row) => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>{row.name}</td>
                      <td>{row.date}</td>
                      <td>{row.amount}</td>
                      <td className="positive">{row.points}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default CompanyProfilePage;
